import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppPWA from './AppPWA';
import App from './App';
import './index.css';

// Funkcja wyboru odpowiedniego komponentu w zależności od domeny
const getAppComponent = () => {
  const hostname = window.location.hostname;
  console.log('🌐 Index.js - Current hostname:', hostname);
  
  if (hostname === 'losuje.pl' || hostname === 'www.losuje.pl') {
    console.log('🎯 Index.js - Używam App.js dla losuje.pl');
    return App;
  } else {
    console.log('🎯 Index.js - Używam AppPWA.js dla innych domen');
    return AppPWA;
  }
};

// React Router v7 future flags
const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

// Service Worker registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker zarejestrowany:', registration);
      })
      .catch((error) => {
        console.log('❌ Błąd rejestracji Service Worker:', error);
      });
  });
}

const AppComponent = getAppComponent();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter {...router}>
      <AppComponent />
    </BrowserRouter>
  </React.StrictMode>
);

